import React, { useState, useEffect } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { RefreshCw, Droplet } from 'lucide-react';
import { toast } from 'sonner';
import stonfiService from '../services/stonfiService';

const STONPools = () => {
  const [pools, setPools] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchPools();
  }, []);

  const fetchPools = async () => {
    setLoading(true);
    try {
      const data = await stonfiService.getPools();
      setPools(data);
    } catch (error) {
      toast.error('Failed to load pools');
    } finally {
      setLoading(false);
    }
  };

  const formatNumber = (num) => {
    return new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }).format(num);
  };

  return (
    <Card data-testid="ston-pools-card">
      <CardHeader>
        <CardTitle className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Droplet className="h-5 w-5" />
            Liquidity Pools
          </div>
          <Button
            size="sm"
            variant="ghost"
            onClick={fetchPools}
            disabled={loading}
            data-testid="refresh-pools-btn"
          >
            <RefreshCw className={`h-4 w-4 ${loading ? 'animate-spin' : ''}`} />
          </Button>
        </CardTitle>
        <CardDescription>
          Available trading pairs on STON.fi
        </CardDescription>
      </CardHeader>
      <CardContent>
        {loading && pools.length === 0 ? (
          <div className="text-center py-8">
            <p className="text-sm text-gray-500">Loading pools...</p>
          </div>
        ) : pools.length === 0 ? (
          <div className="text-center py-8">
            <p className="text-sm text-gray-500">No pools available</p>
          </div>
        ) : (
          <div className="space-y-3">
            {pools.map((pool) => (
              <div
                key={pool.id}
                className="p-4 border rounded-lg hover:bg-gray-50 transition-colors"
                data-testid={`pool-${pool.id}`}
              >
                <div className="flex items-center justify-between mb-3">
                  <div className="flex items-center gap-2">
                    <div className="font-bold text-lg">
                      {pool.token0}/{pool.token1}
                    </div>
                    <div className="px-2 py-1 bg-blue-100 text-blue-700 text-xs rounded">
                      {pool.id}
                    </div>
                  </div>
                  <div className="text-right">
                    <p className="text-sm text-gray-600">Price</p>
                    <p className="font-bold">${pool.price}</p>
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-4 text-sm">
                  <div>
                    <p className="text-gray-600">Liquidity ({pool.token0})</p>
                    <p className="font-medium">{formatNumber(pool.liquidity_ton)}</p>
                  </div>
                  <div>
                    <p className="text-gray-600">Liquidity ({pool.token1})</p>
                    <p className="font-medium">{formatNumber(pool.liquidity_token)}</p>
                  </div>
                  <div className="col-span-2">
                    <p className="text-gray-600">24h Volume</p>
                    <p className="font-medium">${formatNumber(pool.volume_24h)}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default STONPools;
